export const DATA_TABLE_TAG_NAME = "data-table" as const;

export const DATA_TABLE_VARIANTS = ["default", "ghost"] as const;

export const DATA_TABLE_SPACINGS = ["xs", "sm", "md", "lg", "xl"] as const;

export const DATA_TABLE_SCROLLS = ["table", "page"] as const;

export const DATA_TABLE_FILTER_TYPES = [
  "text",
  "number",
  "date",
  "dateRange",
] as const;

export const DATA_TABLE_FILTER_OPERATORS = [
  "contains",
  "equals",
  "startsWith",
  "eq",
  "ne",
  "gt",
  "lt",
  "between",
  "in",
] as const;

export const FILTER_OPERATORS: Record<
  (typeof DATA_TABLE_FILTER_TYPES)[number],
  (typeof DATA_TABLE_FILTER_OPERATORS)[number][]
> = {
  text: ["contains", "equals", "startsWith"],
  number: ["eq", "ne", "gt", "lt", "between"],
  date: ["eq", "gt", "lt", "between"],
  dateRange: ["between"],
};

export const PREFETCH_REACTIVATE_MS = 5000;
